import { useDispatch } from 'react-redux';
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

import { postChannelOauth } from '../../../store/actions/channels';

import { CymbioSpinner } from '../../../components/common/Spinner';
import PageLayout from '../../../components/common/PageLayout';

export function SuppliersConnectChannelIntegration() {
  const dispatch = useDispatch();
  const { search } = useLocation();
  // using ref to only dispatch the action once even if component rerenders
  const postedRef = useRef(false);

  useEffect(() => {
    if (!postedRef.current) {
      dispatch(postChannelOauth(new URLSearchParams(search)));
      postedRef.current = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  return (
    <PageLayout>
      <div style={{ marginTop: '3em', textAlign: 'center' }}>
        <h2>Connecting your Channel...</h2>
        <CymbioSpinner />
      </div>
    </PageLayout>
  );
}
